import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ImageService } from '../../../core/services/image.service';

@Injectable()
export class ProfileResolver implements Resolve<any> {
  constructor(private imageService: ImageService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.imageService.requestProfileImage().catch((error) => console.log('No image for user'));
  }
}
